var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ' ');
    decimal   = defaultOption(decimal, ',');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class CartManager {
  constructor() {
    
  }

  getCart = async () => {
    return await fetch(`/cart.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
    .then(response => response.json())
    .then(data => {
      data.progress_bar_excluded_item = 7379504758948
      const excludedItems = data.progress_bar_excluded_item
      const cartItems = data.items
      
      cartItems.forEach((item) => {
        if(item.product_id == excludedItems){
          data.total_price = parseInt(data.total_price - item.final_line_price);
        }
      })
      return data;
    })
    .catch(error => console.error('Error getting cart:', error));
  }
}

const cartManager = new CartManager();

// Progress bar
customElements.define('progressbar-rewards', class ProgressBarRewards extends HTMLElement {
  constructor() {
    super();

    let selectors = {
      "progressSettings" : "[data-progressbar-rewards-settings]",
      "progressSettingsData" : "progressbarRewardsSettings",
      "progressCurrentMessage" : "[data-progressbar-rewards--current-message]",
      "progressNextMessage" : "[data-progressbar-rewards--next-message]",
      "progressImage" : "[data-progressbar-rewards--image]",
      "progressBarContainer" : "[data-progressbar-rewards--progress-bar-container]",
      "progressBar" : "[data-progressbar-rewards--progress-bar]",
      "progressThreshold" : "[data-progressbar-rewards--threshold]",
      "progressThresholdMarker" : "[data-progressbar-rewards--threshold-marker]",
    };

    this.selectors = selectors;
    this.too_many_requests = false;

    this.init();
  }

  // getCookieItemReward(name) {
  //   var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  //   return v ? v[2] : null;
  // }

  // setCookieItemReward(name, value, days) {
  //   var d = new Date;
  //   d.setTime(d.getTime() + 24*60*60*1000*days);
  //   document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  // }

  // deleteCookieItemReward(name) { 
  //   this.setCookieItemReward(name, '', -1);
  // }

  async checkOldRewardsNotInStepsAnymore(cart, packSettingsData) {
    const allRewardsInCart = this.allRewardsInCart(cart);

    for (let reward of allRewardsInCart) {
      const rewardInSteps = packSettingsData.steps.find(step => step.variant_id == reward.id);

      if (!rewardInSteps) {
        await this.updateItemById(reward.key, 0);
      }
    }
  }

  async checkSteps(cart, packSettingsData) {
    for (let step of packSettingsData.steps) {
      if (step.type != 'product') continue;

      const itemAlreadyInCart = cart.items.find(item => item.variant_id == step.variant_id);

      // If the step is not reached, we check if the product is in the cart
      // If it is, we remove it
      if (step.threshold > cart.total_price && itemAlreadyInCart) {
        await this.updateItemById(itemAlreadyInCart.key, 0);
      } else if (step.threshold <= cart.total_price && !itemAlreadyInCart && step.variant_id) {
        await this.addItem(step.variant_id, 1, step.threshold, step.id);
      }
    }
  }

  async updateGiftsInCart() {
    let packSettingsData = JSON.parse(this.querySelector(this.selectors.progressSettings).dataset[this.selectors.progressSettingsData]);
    const cart = await cartManager.getCart();

    await this.checkSteps(cart, packSettingsData);
    await this.checkOldRewardsNotInStepsAnymore(cart, packSettingsData);
  }

  variantIsAlreadyInCart(cart, rewardId) {
    return cart.items.some(item => item.variant_id == rewardId);
  }

  allRewardsInCart(cart) {
    return cart.items.filter(item => item.properties && item.properties._is_reward);
  }

  async initOrUpdateProgressBar() {
    let packSettingsData = JSON.parse(this.querySelector(this.selectors.progressSettings).dataset[this.selectors.progressSettingsData]);

    let progressCurrentMessage = this.querySelector(this.selectors.progressCurrentMessage);
    let progressNextMessage = this.querySelector(this.selectors.progressNextMessage);
    let progressImage = this.querySelector(this.selectors.progressImage);
    let progressBarContainer = this.querySelector(this.selectors.progressBarContainer);
    let progressBar = this.querySelector(this.selectors.progressBar);
    let progressThresholds = this.querySelectorAll(this.selectors.progressThreshold);
    let progressThresholdMarkers = this.querySelectorAll(this.selectors.progressThresholdMarker);

    const cart = await cartManager.getCart();

    var currentStep = null;
    var nextStep = null;
    for (let index = 0; index < packSettingsData.steps.length; index++) {
      if (cart.total_price >= parseInt(packSettingsData.steps[index].threshold)) {
        currentStep = packSettingsData.steps[index];
        nextStep = packSettingsData.steps[index + 1];
      }
    }

    // console.log("packSettingsData", packSettingsData);
    // console.log("currentStep", currentStep);
    // console.log("nextStep", nextStep);

    // None step reach
    if (currentStep == null && nextStep == null) {
      nextStep = packSettingsData.steps[0];
    }

    let lastStepReach = currentStep != null && nextStep == null ? true : false;

    // set markers position
    if (progressThresholdMarkers != null) {
      progressThresholds.forEach(function callback(threshold, index) {
        threshold.style.left = (index + 1) / (progressThresholdMarkers.length + 1) * 100 + '%';
      });
    }

    // If current step is product and not already in cart, we add the product
    if (currentStep != null && currentStep.type == 'product') {
      var productIsAlreadyAdded = false;

      productIsAlreadyAdded = await this.variantIsAlreadyInCart(cart, currentStep.variant_id);

      if (!productIsAlreadyAdded && currentStep.variant_id) {
        await this.addItem(currentStep.variant_id, 1, currentStep.threshold, currentStep.id);
      }
    }

    if (!lastStepReach) {
      var leftBeforeThreshold = '<span class="scz-cart-rewards__price-left">' + Shopify.formatMoney(parseInt(nextStep.threshold) - cart.total_price) + '</span>';
      var nextMessage = nextStep.before_message.replace('##left##', leftBeforeThreshold);
      var nextImage = nextStep.image;
      var nextTreshold = parseInt(nextStep.threshold);
    } else {
      var nextMessage = currentStep.after_message;
      var nextImage = currentStep.image;
      var nextTreshold = parseInt(currentStep.threshold);
    }

    progressImage.src = nextImage;
    progressNextMessage.innerHTML = nextMessage.replace("##%##", "'");

    if (progressThresholds != null) {
      progressThresholds.forEach(function callback(treshold, index) {
        if (treshold.dataset["progressbarRewards-Threshold"] <= cart.total_price) {
          treshold.classList.add('active');
        } else {
          treshold.classList.remove('active');
        }
      }); 
    }

    // Update progress bar
    if (lastStepReach) {
      progressBar.style.width = "100%";
    } else {
      var cartTotalPrice = parseFloat(cart.total_price) / 100;
      var nextThreshold = this.querySelector('[data-progressbar-rewards--threshold="'+ nextTreshold.toString() +'"]');
      const allActiveThreshold = this.querySelectorAll('.active[data-progressbar-rewards--threshold]');

      if (nextThreshold != null) {
        var nextThresholdValue = parseInt(nextThreshold.getAttribute("data-progressbar-rewards--threshold")) / 100;
        var nextThresholdPosition = parseFloat(nextThreshold.style.left);
        let startingPosition = 0;

        if (allActiveThreshold.length > 1) {
          const currentThreshold = allActiveThreshold[allActiveThreshold.length - 1];
          const currentThresholdPosition = parseFloat(currentThreshold.style.left);

          startingPosition = currentThresholdPosition;
        }

        const percentageUntilNextThreshold = (cartTotalPrice * 100) / nextThresholdValue;
        const percentage = startingPosition + ((nextThresholdPosition - startingPosition) * percentageUntilNextThreshold / 100);

        progressBar.style.width = percentage + "%"; 
      } else {
        progressBar.style.width = "100%";
      }
    }
  }

  async init() {
    if(this.querySelector(this.selectors.progressSettings) != null) {
      document.addEventListener("elkad:cart:built", async (e) => {
        await this.initOrUpdateProgressBar();
        this.updateGiftsInCart();
      });

      await this.initOrUpdateProgressBar();
      this.updateGiftsInCart();
    }        
  }

  async addItem(variantId, quantity, threshold, id) {
    if (this.too_many_requests) return;
    const result = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: {
            '_is_reward': true,
            '_reward_id': id,
            '_reward_threshold': threshold,
          }
        })
    }).then((response) => {
      if (response.status == 429) {
        this.too_many_requests = true;
      }
      return response.text();
    })
    .then((state) => {
      document.dispatchEvent(
        new CustomEvent("elkad:cart:add", { bubbles: !0 })
      )
    })
    .catch((e) => {
      console.error(e);
      this.querySelectorAll('.loading-overlay').forEach((overlay) =>
        overlay.classList.add('hidden'),
      );
    });
  }

  async updateItem(data) {
    const result = await fetch("/cart/change", {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
      },
      body: JSON.stringify(data)
    }).then((response) => {
      return response.text();
    })
    .then((state) => {
      document.dispatchEvent(
        new CustomEvent("elkad:cart:add", { bubbles: !0 })
      )
    })
    .catch((e) => {
      console.error(e);
    });
  }
  
  updateItemById(lineItemId, newQuantity, newProperties = {}) {
    return this.updateItem({
      id: lineItemId,
      quantity: newQuantity,
      properties: newProperties
    });
  }
});